.input {
  min-height: 36px;
}
